import { useAppSelector } from "..";

export function useUser() {
  return useAppSelector(({ auth }) => auth.user);
}
